// Male & Female silhouettes whose heights scale to the gender split.
// Used inside each beneficiary-type infographic card.

const FEMALE_PATH =
  // Head + flared dress silhouette
  "M50 8 a8 8 0 1 1 0 16 a8 8 0 1 1 0 -16 z " +
  "M42 26 h16 l8 36 h-12 l-4 22 h-8 v-22 h-12 l-8 -36 h12 z";

const MALE_PATH =
  // Head + shoulders + straight torso silhouette
  "M50 8 a8 8 0 1 1 0 16 a8 8 0 1 1 0 -16 z " +
  "M38 26 h24 l4 14 h-6 v44 h-8 v-22 h-4 v22 h-8 v-44 h-6 z";

export default function GenderSilhouettes({ female = 0, male = 0 }) {
  const total = female + male;
  if (total === 0) return null;

  const femalePct = Math.round((female / total) * 100);
  const malePct   = 100 - femalePct;

  // Map percentage to a visual height (min 25% so even small shares are visible)
  const heightFor = (pct) => 35 + (pct / 100) * 65; // 35% .. 100%

  const fH = heightFor(femalePct);
  const mH = heightFor(malePct);

  // No women in segment (e.g., 100% male) — fade female silhouette
  const femaleOpacity = female === 0 ? 0.18 : 1;
  const maleOpacity   = male   === 0 ? 0.18 : 1;

  return (
    <div className="w-full mt-2" data-testid="gender-silhouettes">
      <div className="flex items-end justify-center gap-3" style={{ height: 56 }}>
        {/* Female silhouette */}
        <div className="flex flex-col items-center" style={{ height: "100%" }}>
          <svg
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMax meet"
            style={{ height: `${fH}%`, width: "auto", opacity: femaleOpacity }}
          >
            <path d={FEMALE_PATH} fill="#EC4899" />
          </svg>
        </div>
        {/* Male silhouette */}
        <div className="flex flex-col items-center" style={{ height: "100%" }}>
          <svg
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMax meet"
            style={{ height: `${mH}%`, width: "auto", opacity: maleOpacity }}
          >
            <path d={MALE_PATH} fill="#6B7280" />
          </svg>
        </div>
      </div>
      {/* Numeric labels */}
      <div className="flex items-center justify-center gap-3 mt-1 text-[9px] font-bold tracking-wider">
        <span className="text-pink-600">{femalePct}%</span>
        <span className="text-blue-600">{malePct}%</span>
      </div>
    </div>
  );
}
